var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.05 10.514 4.644 8.656a2.333 2.333 0 1 1 0-3.312L8.05 3.486a2.333 2.333 0 1 1 .639 1.17L5.283 6.514a2.3 2.3 0 0 1 0 .972l3.406 1.858a2.333 2.333 0 1 1-.639 1.17"
  })));
};
export default SvgIconShare;